import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";

const ExecutionEntryCanceled = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry />
    </>
  );
}

export default ExecutionEntryCanceled;
